import React from "react";
import "./SizeCard.css";

/* ================================================================== */
/*  Card ke 8 main fields (hamesha dikhte hain)                       */
/*  key = Refill.js ke normalize() wali key                           */
/* ================================================================== */

const MAIN_FIELDS = [
    { key: "aoBisDatum", label: "A/O Bis Datum" },
    { key: "lstBstDatum", label: "LstBst Datum" },
    { key: "newBest", label: "New Best" },
    { key: "abvekNach", label: "Abvek Nach" },
    { key: "offnAuf", label: "Offn Auf" },
    { key: "grundBest", label: "Grund Best" },
    { key: "kalkBest", label: "Kalk Best" },
    { key: "bedrfMangQt", label: "Bedrf MangQt" },
];

/* ================================================================== */
/*  Extra fields ka fixed order (+ dabane par)                        */
/*  2 fields ek row me:                                               */
/*    LstBst | Artikel                                                */
/*    Col    | Dim                                                    */
/*    Last order date | Rech. Im Tag                                  */
/*    Gültig Von Dt   | Gültig Bis Dt   (dono beside me)              */
/*    A/I Sts                           (neeche akela)                */
/* ================================================================== */

const EXTRA_ORDER = [
    "LstBst",
    "Artikel",
    "Col",
    "Dim",
    "Gro",
    "RechImTag",
    "GultingVonDt",
    "GultingBisDt",
    "A/ISts",
];

// Order list me jo key nahi hai wo sabse last me jayegi
const extraRank = (key) => {
    const i = EXTRA_ORDER.indexOf(key);
    return i === -1 ? 999 : i;
};

/* ================================================================== */
/*  Ek field (label + input)                                          */
/*  key={text} se input tab refresh hota hai jab API value badalti hai */
/* ================================================================== */

const Field = ({ label, subLabel, value, readOnly = false }) => {
    const text = value === null || value === undefined ? "" : String(value);

    return (
        <div className="size_card_row">
            <div className="size_card_label">
                {label}
                {subLabel && <small className="size_card_label_de">{subLabel}</small>}
            </div>
            <input
                key={text}
                type="text"
                className="form-control size_card_input"
                placeholder={label}
                defaultValue={text}
                readOnly={readOnly}
            />
        </div>
    );
};

/* ================================================================== */
/*  SizeCard                                                          */
/*                                                                    */
/*  Props:                                                            */
/*   size         "XXS", "M" ...                                      */
/*   progress     0 se 100                                            */
/*   isOpen       extra fields dikhane hain ya nahi                   */
/*   onToggle     + / - button click                                  */
/*   extraFields  + dabane par khulne wale fields [{ key, label, de }] */
/*   data         is size ka API data (normalize() ke baad)           */
/* ================================================================== */

const SizeCard = ({
    size,
    progress = 0,
    isOpen = false,
    onToggle,
    extraFields = [],
    data = {},
}) => {
    // Extra fields ko fixed order me lagao
    const sortedExtraFields = [...extraFields].sort(
        (a, b) => extraRank(a.key) - extraRank(b.key)
    );

    return (
        <div className="size_card_wrap">
            <div className="card size_card">
                <div className="card-body">
                    {/* Header: size + toggle button */}
                    <div className="size_card_head">
                        <h4 className="size_card_title">{size}</h4>
                        <button
                            type="button"
                            className="btn-text theme-inverse size_card_toggle"
                            onClick={onToggle}
                            aria-expanded={isOpen}
                            aria-label={`${isOpen ? "Hide" : "Show"} details for ${size}`}
                        >
                            {isOpen ? "−" : "+"}
                        </button>
                    </div>

                    {/* Progress bar */}
                    <div
                        className="progress size_card_progress"
                        role="progressbar"
                        aria-label={`${size} progress`}
                        aria-valuenow={progress}
                        aria-valuemin="0"
                        aria-valuemax="100"
                    >
                        <div
                            className="progress-bar progress-bar-striped progress-bar-animated"
                            style={{ width: `${progress}%` }}
                        ></div>
                    </div>

                    {/* Main fields (hamesha) */}
                    <div className="size_card_fields">
                        {MAIN_FIELDS.map((f) => (
                            <Field key={f.key} label={f.label} value={data[f.key]} />
                        ))}
                    </div>

                    {/* Auto-order pill */}
                    <div className="size_card_auto">
                        <p>Auto-order +5</p>
                    </div>

                    {/* Extra fields (+ dabane par) */}
                    {isOpen && (
                        <div className="size_card_fields">
                            {sortedExtraFields.map((f) => (
                                <Field
                                    key={f.key}
                                    label={f.label}
                                    subLabel={f.de}
                                    value={data[f.key]}
                                    readOnly
                                />
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SizeCard;